import { useQuery } from '@apollo/client'
import { useTranslate } from '@ur-solutions/react-hooks'
import { GENERATION_PREVIEW_ANCHOR } from './generation-preview-tool'
import { SALARY_GENERATION_RULES_LIVE_QUERY } from './queries'

/** While the generation rules are preview only, say so at the top of the page. */
export const BetaPreviewHint: React.FC = () => {
  const texts = useTranslate({
    hint: 'settings.generation-preview.beta-hint',
    link: 'settings.generation-preview.menu',
  })
  const { data } = useQuery(SALARY_GENERATION_RULES_LIVE_QUERY)
  if (data?.salaryGenerationRulesLive !== false) return null

  return (
    <p className="rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900">
      {texts.hint}{' '}
      <a
        href={`#${GENERATION_PREVIEW_ANCHOR}`}
        className="font-semibold underline"
      >
        {texts.link}
      </a>
    </p>
  )
}
